<template>
  <div>
    <el-alert v-if="hasError" class="mb-2" :title="errorMessage" type="error" :closable="false" />
    <loader v-else-if="loading" />
    <custom-component-renderer v-else v-bind="component" :panel-uid="panelUid" />
  </div>
</template>

<script>
import { parseComponent } from 'vue-template-compiler'
import { get, isEmpty } from 'lodash'
import Loader from '../Loader'
import CustomComponentRenderer from './CustomComponentRenderer.vue'

export default {
  name: 'CustomComponentLoader',
  components: {
    CustomComponentRenderer,
    Loader,
  },
  props: {
    componentName: {
      type: String,
      default: 'Unnamed Component',
    },
    componentType: {
      type: String,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    namespace: {
      type: String,
    },
    previewComponent: {
      type: String,
      default: '',
    },
    panelUid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      component: {},
      loading: true,
      hasError: false,
      errorMessage: '',
    }
  },
  methods: {
    fetchComponent() {
      this.$client
        .execute({
          operationId: 'CustomComponents_getComponent',
          parameters: {
            componentName: this.componentType || this.componentName,
            date: Date.now(),
          },
        })
        .then(({ body }) => {
          if (!isEmpty(body)) {
            const component = get(body, 'vueContent', `<template>{{ i18n.t('empty_component') }}</template>`)
            this.prepareComponent(component)
          } else {
            this.component.template = `<template>${this.$i18n.t('no_component_found')}</template>`
            this.loading = false
          }
        })
    },
    prepareComponent(component) {
      try {
        const newComponent = parseComponent(component)
        const script = get(newComponent, 'script.content', '{}')
        newComponent.options = eval(`(${script.replace('export default ', '')})`)
        newComponent.namespace = this.namespace
        newComponent.styles = get(newComponent, 'styles[0].content', '')
        newComponent.template = get(newComponent, 'template.content', '')
        this.hasError = false
        this.component = newComponent
      } catch (error) {
        this.errorMessage = error.message
        this.hasError = true
      }
      this.$emit('component-error', this.hasError)
      this.loading = false
    },
  },
  mounted() {
    if (this.isPreview) {
      this.prepareComponent(this.previewComponent)
    } else {
      this.fetchComponent()
    }
  },
  watch: {
    previewComponent: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loading = true
          this.prepareComponent(this.previewComponent)
        }
      },
    },
  },
}
</script>
